import React from 'react';
import { Typography, Grid } from '@mui/material';

const NoDataComponent = () => (
  <>
    <Grid container direction="row" justifyContent="center" alignItems="center" style={{ paddingTop: '8%' }}>
      <Grid item md={12} sm={12} xs={12} style={{ textAlign: 'center' }}>
        <Typography variant="h4" color="textSecondary">
          Oops...! <br /> No Data Available...!
        </Typography>
      </Grid>
    </Grid>
  </>
);

export default NoDataComponent;
